import { render, staticRenderFns } from "./BaseNavigation.vue?vue&type=template&id=7daae242&"
import script from "./BaseNavigation.vue?vue&type=script&lang=ts&"
export * from "./BaseNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports